import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { uniqBy } from 'lodash-es';
import { regionFixedExchangeRate, RegionFixedExchangeRateValue } from 'services/config/region';
import { Select } from 'antd';

const Extra = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  .desc {
    color: #84868c;
  }
  .ant-select-selector,
  .ant-select-selection-placeholder {
    color: #336fff;
  }
`;
interface Props {
  onCurrencyChange: (val: RegionFixedExchangeRateValue) => void;
  currency?: RegionFixedExchangeRateValue;
}

export const currencyOptions = uniqBy(
  Object.values(regionFixedExchangeRate).map(({ region, shorthand, ...rest }) => ({
    label: shorthand,
    value: region,
    region,
    shorthand,
    ...rest,
  })),
  'shorthand',
);

const CurrencySelector = (props: Props) => {
  const { t } = useTranslate();
  const { onCurrencyChange, currency } = props;
  return (
    <Extra>
      {currency && currency.region !== 'CN' && (
        <div className="desc">
          {t('ViewDashboard.履约数据.汇率提示', {
            info: `1RMB≈${currency.rate}${currency.shorthand}`,
          })}
        </div>
      )}
      <div>
        <span>{t('ViewDashboard.履约数据.金额货币为')}</span>
        <Select
          options={currencyOptions}
          allowClear
          bordered={false}
          value={currency?.region}
          placeholder="CNY"
          dropdownMatchSelectWidth={false}
          onChange={(_, option) => {
            onCurrencyChange(option as any);
          }}
        />
      </div>
    </Extra>
  );
};

export default CurrencySelector;
